import { render, staticRenderFns } from "./NaviSetting.vue?vue&type=template&id=85dd8c4c&scoped=true"
import script from "./NaviSetting.vue?vue&type=script&lang=js"
export * from "./NaviSetting.vue?vue&type=script&lang=js"
import style0 from "./NaviSetting.vue?vue&type=style&index=0&id=85dd8c4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dd8c4c",
  null
  
)

export default component.exports